var Accessory = function () {
  var _ = {

    _$acrIds: undefined,
    _def: {
      checkbox:  'acr-product_id',
      qInput:    'acr-input_product_id',
      priceSum:  'acr-price-sum',
      acrPrice:  'acr-price',
      acrAddIds: 'acs-add-ids',
      acrSubmit: 'acr-submit',
      addSubmit: 'add-submit'
    },

    /**
     * Inicializace funkcionality - prisuslusentstvi do kosiku
     */
    init: function () {
      _._initIdsContainer();
      _._changeSumPrice();

      $(document)
        .on(
          'change',
          '[data-' + _._def.checkbox + ']',
          _._changeCheckboxListener
        );
      $(document)
        .on('change', '[data-' + _._def.qInput + ']', _._changeQinputListener);
      $(document)
        .on('click', '[data-' + _._def.acrSubmit + ']', _._acrSubmitListener);
      $(document)
        .on('click', '[data-' + _._def.addSubmit + ']', _._addSubmitListener);
    },

    /**
     *
     * @private
     */
    _initIdsContainer: function () {
      _._$acrIds = $('[data-' + _._def.acrAddIds + ']');
    },

    /**
     *
     * @param e
     * @private
     */
    _changeCheckboxListener: function (e) {
      var $this     = $(e.target),
          productId = $this.data(_._def.checkbox),
          qInput    = $('[data-' + _._def.qInput + '="' + productId + '"]');

      if ($this.is(':checked')) {
        qInput.val(1);
        qInput.trigger('change');
        return;
      }

      qInput.val(0);
      qInput.trigger('change');
    },

    /**
     *
     * @private
     */
    _changeQinputListener: function (e) {
      var $this     = $(e.target),
          value     = $this.val(),
          productId = $this.data(_._def.qInput),
          $checkbox = $('[data-' + _._def.checkbox + '="' + productId + '"]');

      if (value >= 1) {
        $checkbox.prop('checked', true);
      }
      else {
        $checkbox.prop('checked', false);
      }

      _._changeSumPrice();
    },

    /**
     *
     * @private
     */
    _changeSumPrice: function () {
      var $priceSum = $('[data-' + _._def.priceSum + ']'),
          text      = new Intl
            .NumberFormat('cs-CZ')
            .format(_._calcSumPrice());

      $priceSum.text(text);
    },

    /**
     *
     * @private
     */
    _calcSumPrice: function () {
      var acsrPrice = 0;

      $('[data-' + _._def.qInput + ']')
        .each(function (index, element) {
          var $elm  = $(element),
              price = $elm.data(_._def.acrPrice),
              q     = $elm.val();

          if (typeof price === 'string') {
            price = price.replace(' ', '');
          }

          acsrPrice += parseFloat(price) * parseInt(q);
        });

      return acsrPrice;
    },

    /**
     *
     * @private
     */
    _setIds: function () {
      var checkboxes = $('[data-' + _._def.checkbox + ']:checked'),
          data       = [];

      checkboxes.each(function (index, elm) {
        var $elm    = $(elm),
            id      = $elm.data(_._def.checkbox),
            $qInput = $('[data-' + _._def.qInput + '="' + id + '"]'),
            q       = parseInt($qInput.val());

        data.push([id, q]);
      });

      _._initIdsContainer();

      _._$acrIds.val(JSON.stringify(data));
    },

    /**
     *
     * @private
     */
    _acrSubmitListener: function () {
      _._setIds();

      $("#add-product-form").submit();
    },

    /**
     *
     * @private
     */
    _addSubmitListener: function () {
        _._initIdsContainer();

        _._$acrIds.val(null);

        $('[data-' + _._def.addSubmit + ']').closest('form').submit();
    }
  };

  return _;
};

$(function () {
  var A = Accessory();
  A.init();
});